import React from 'react';
import { ReactComponent as Icon } from '../../assets/images/icon-send-2.svg';

const SvgIcon = ({ fillColor }) => {
  return <Icon style={{ fill: fillColor }} />;
};

export default SvgIcon;
